import api from "!../../modal/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../modal/node_modules/css-loader/dist/cjs.js??ref--6!./web3auth.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};